import { render, staticRenderFns } from "./CreateFormulationPopUp.vue?vue&type=template&id=282011cd&scoped=true&"
import script from "./CreateFormulationPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateFormulationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateFormulationPopUp.vue?vue&type=style&index=0&id=282011cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282011cd",
  null
  
)

export default component.exports